var React = require('react');

function UndercoverParkingInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("path",{"strokeLinecap":"square","d":"M4 18L32 8l28 10M33 53H12V42.613C12 40.204 13.666 39 16.999 39H47c3.334 0 5 1.204 5 3.613V53H33z","key":0}),React.createElement("path",{"d":"M20 48a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm24 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zM32 26h7c4.5 0 4.963 1.11 7 6 1.358 3.26 2.358 5.593 3 7H15c.642-1.407 1.642-3.74 3-7 2.037-4.89 2.5-6 7-6h7zM18 53v6m28-6v6","strokeLinecap":"square","key":1}),React.createElement("path",{"d":"M8 16.5v43.503M56 16.5v43.503","key":2})]));
}

UndercoverParkingInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = UndercoverParkingInline;

UndercoverParkingInline.default = UndercoverParkingInline;
